import { motion } from "framer-motion";
import type { WineCardData } from "./types";
import { wineCardSections } from "../../src/lib/wine-card-sections";

export function WineCard({ data }: { data: WineCardData }) {
  const sections = wineCardSections(data.intelligence ?? {});
  return (
    <motion.div className="mw-card-wrap" initial={{ opacity: 0, y: 12, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.45 }}>
      <article className="mw-card">
        <header className="mw-card-header">
          <h3 className="mw-card-name">Wine Intelligence Card</h3>
        </header>
        {sections.map((section, index) => (
          <section className="mw-intelligence-section" key={section.title}>
            <div className="mw-section-heading">
              <h4>{section.title}</h4>
              <span className={`mw-provenance-badge ${index === 0 ? "mw-verified" : "mw-estimated"}`}>{section.badge}</span>
            </div>
            <p className="mw-card-notes-label">{section.description}</p>
            <dl className="mw-card-grid">
              {section.fields.map(([label, value]) => (
                <div key={label}>
                  <dt className="mw-stat-label">{label}</dt>
                  <dd className="mw-stat-value mw-mono">{value}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </article>
    </motion.div>
  );
}
